import React, { useState, useEffect, useRef } from "react"; // ✅ include useRef

//import React, { useState, useEffect } from "react";
import axios from "axios";

/**
 * FINAL ORDERCREATE.JSX
 * Combines all the functionality we've worked on:
 *  1. Fetching products, staff, couriers, payment methods, call types
 *  2. Handling subscription data (from localStorage) to prefill
 *  3. Displaying a dynamic form for products
 *  4. Calculating total_amount
 *  5. Distinguishing subscription-based orders vs. manual orders
 *  6. Submitting the order, auto-approving if from subscription (if needed)
 */

const OrderCreate = ({ onOrderAdded, order }) => {
  // ----------------------
  // FORM DATA
  // ----------------------

  const [persistentCaller, setPersistentCaller] = useState("");
  const [persistentProducts, setPersistentProducts] = useState([
    { productId: '', productName: '', quantity: 1, price: 0 }
  ]);
  

  const [formData, setFormData] = useState({
    order_no: "", // ✅ Add order number
    customer_name: "",
    order_date: new Date().toISOString().split("T")[0],
    order_time: new Date().toLocaleTimeString("en-US", { hour12: false }),
    total_amount: 0,
    products: [{ productId: '', productName: '', quantity: 1, price: 0 }],
    shipping_address: "",
    assigned_to: "",
    courier: "",
    pin: "",
    mobile: "",
    so: "",
    village: "",
    city: "",
    district: "",
    state: "",
    payment_method: "",
    discount: 0,
   // call_type: "",
    _id: null,
    sent_to_caller: false, // ✅ New field to control visibility to caller
  });
  


  // ----------------------
  // OTHER STATES
  // ----------------------
  const [products, setProducts] = useState([]);
  const [staffMembers, setStaffMembers] = useState([]);
  const [couriers, setCouriers] = useState([]);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  // Merged staff usage:
  const [teamMembers, setTeamMembers] = useState([]); // might not be used
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [callTypes, setCallTypes] = useState([]);

  const villagePanelRef = useRef(null);
  

  const villageListRef = useRef(null);
  const courierRef = useRef(null);
  

  // ----------------------
  // USEFFECT - FETCH ALL DATA
  // ----------------------

  useEffect(() => {
    const handleShortcut = (event) => {
      if (event.shiftKey && event.key === "V") {
        event.preventDefault();
        document.getElementById("villageListPanel")?.focus();
      }
    };
  
    window.addEventListener("keydown", handleShortcut);
    return () => {
      window.removeEventListener("keydown", handleShortcut);
    };
  }, []);
  



  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
  
        // 🏆 Fetch all API data in parallel for better performance
        const [
          productResponse,
          teamResponse,
          courierResponse,
        //  callTypeResponse,
          paymentMethodResponse,
        ] = await Promise.all([
          axios.get("https://astrovidhya.in/api/products"),
          axios.get("https://astrovidhya.in/api/staff", { headers: { Authorization: `Bearer ${token}` } }),
          axios.get("https://astrovidhya.in/api/couriers/active"),
         // axios.get("https://astrovidhya.in/api/call-types"),
          axios.get("https://astrovidhya.in/api/payment-methods"),
        ]);
  
        // ✅ Debugging - Log API responses
        console.log("✅ API Response for Products:", productResponse.data);
       // console.log("✅ API Response for Call Types:", callTypeResponse.data);
  
        // ✅ Store products in state with proper validation
        if (productResponse.data && Array.isArray(productResponse.data)) {
          setProducts(productResponse.data);
          console.log("✅ Products stored in state:", productResponse.data);
        } else {
          console.error("❌ Invalid product response:", productResponse.data);
        }
  
        // ✅ Store staff
        setTeamMembers(teamResponse.data);
        setStaffMembers(teamResponse.data);
  
        // ✅ Store couriers
        setCouriers(courierResponse.data);
  
        // ✅ Store call types with validation
        if (callTypeResponse.data && Array.isArray(callTypeResponse.data)) {
       //   setCallTypes(callTypeResponse.data);
          console.log("✅ Call Types stored in state:", callTypeResponse.data);
        } else {
          console.error("❌ Invalid call type response:", callTypeResponse.data);
        }
  
        // ✅ Store payment methods
        setPaymentMethods(paymentMethodResponse.data);
  
        // ✅ Handle subscription data
        const subscriptionData = JSON.parse(localStorage.getItem("subscriptionData"));
        if (subscriptionData) {
          console.log("🚀 Subscription Data Loaded:", subscriptionData);
  
          setFormData((prev) => ({
            ...prev,
            customer_name: subscriptionData.customer_name || "",
            mobile: subscriptionData.mobile || "",
            shipping_address: subscriptionData.shipping_address || "",
            pin: subscriptionData.pin || "",
            city: subscriptionData.city || "",
            state: subscriptionData.state || "",
            products: subscriptionData.products || [],
            assigned_to: subscriptionData.assigned_to || "",
            call_type: subscriptionData.call_type || "",
            payment_method: subscriptionData.payment_method || "",
          }));
  
          localStorage.removeItem("subscriptionData");
        }
  
      } catch (error) {
        console.error("❌ Error fetching data:", error);
    //    alert("Failed to load data. Please try again.");
      }
    };
  
    fetchData();
  }, []);
  

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await axios.get("https://astrovidhya.in/api/payment-methods");
        console.log("✅ Fetched Payment Methods:", response.data); // Debugging
        setPaymentMethods(response.data);
      } catch (error) {
        console.error("❌ Error fetching payment methods:", error);
      }
    };
  
    fetchPaymentMethods();
  }, []);
  

  // ----------------------
  // USEFFECT - if editing an existing order
  // ----------------------
  useEffect(() => {
    if (order) {
      console.log("Editing existing order:", order);
  
      setFormData((prev) => ({
        ...prev,
        customer_name: order.customer_name || "",
        order_date: order.order_date ? order.order_date.split("T")[0] : prev.order_date,
        order_time: order.order_time || prev.order_time,
        total_amount: order.total_amount || 0,
        discount: order.discount || 0,
        products: order.products || [],
        shipping_address: order.shipping_address || "",
        assigned_to: order.assigned_to?._id || "",
        courier: order.courier?._id || "",
        pin: order.pin || "",
        mobile: order.mobile || "",
        so: order.so || "",  // ✅ Ensure "so" is populated
        village: order.village || "",
        city: order.city || "",
        district: order.district || "",
        state: order.state || "",
        payment_method: order.payment_method || "",
     //   call_type: order.call_type || "",
        _id: order._id || null,
      }));
  
      console.log("✅ FormData after setting order:", formData); // Debugging
    }
  }, [order]);
  

  // ----------------------
  // HELPER - calculateTotalAmount
  // ----------------------
  const calculateTotalAmount = (productsList, discount) => {
    if (!productsList || productsList.length === 0) {
      setFormData((prev) => ({ ...prev, total_amount: 0 }));
      return;
    }
    const subtotal = productsList.reduce((sum, p) => {
      const price = p.price || 0;
      const qty = p.quantity || 1;
      return sum + price * qty;
    }, 0);

    setFormData((prev) => ({
      ...prev,
      total_amount: Math.max(subtotal - (discount || 0), 0),
    }));
  };

  // ----------------------
  // USEFFECT - whenever products or discount change
  // ----------------------
  useEffect(() => {
    calculateTotalAmount(formData.products, formData.discount);
  }, [formData.products, formData.discount]);


 {/* useEffect(() => {
    const handleOrderSelection = (event) => {
      const { courierName, callerName } = event.detail;
      
      console.log("✅ Updating fields:", { courierName, callerName });
  
      // ✅ Ensure formData is updated immediately
      setFormData(prev => ({
        ...prev,
        courier: couriers.find(c => c.name === courierName)?._id || "", 
        assigned_to: staffMembers.find(s => s.name === callerName)?._id || ""
      }));
  
      // ✅ Force re-render to reflect the update
      setTimeout(() => setFormData(prev => ({ ...prev })), 0);
    };
  
    window.addEventListener("orderSelected", handleOrderSelection);
  
    return () => {
      window.removeEventListener("orderSelected", handleOrderSelection);
    };
  }, [couriers, staffMembers]); */}

  useEffect(() => {
    const handleOrderSelection = (event) => {
      const {
        courierName,
        callerName,
        so,
        customer_name,
        mobile,
        shipping_address,
        pin,
        city,
        district,
        state,
        products,
        payment_method,
      //  call_type,
        discount,
        village,
      } = event.detail;
  
      setFormData((prev) => ({
        ...prev,
        courier: couriers.find((c) => c.name === courierName)?._id || "",
        assigned_to: staffMembers.find((s) => s.name === callerName)?._id || "",
        so: so || "",
        customer_name,
        mobile,
        shipping_address,
        pin,
        city,
        district,
        state,
        products,
        payment_method,
        call_type,
        discount,
        village,
      }));
  
      console.log("🧠 Form pre-filled from order history.");
    };
  
    window.addEventListener("orderSelected", handleOrderSelection);
  
    return () => {
      window.removeEventListener("orderSelected", handleOrderSelection);
    };
  }, [couriers, staffMembers]);
  
  
  
  

  
  // ----------------------
  // HANDLERS FOR FORM
  // ----------------------


  const handleMobileKeyDown = async (e) => {
    if (e.key === "Enter") {
      const mobile = formData.mobile.trim();
      if (!/^\d{10}$/.test(mobile)) {
        alert("Please enter a valid 10-digit mobile number.");
        return;
      }
  
      try {
        console.log("🚀 Searching for orders with mobile:", mobile);
        const response = await axios.get(`https://astrovidhya.in/api/orders`);
        const allOrders = response.data;
  
        // ✅ Find orders matching the mobile number
        const matchedOrders = allOrders.filter((order) => order.mobile === mobile);
  
        console.log("✅ Orders Found:", matchedOrders);
  
        if (matchedOrders.length > 0) {
          console.log("✅ Dispatching event to display orders...");
          window.dispatchEvent(new CustomEvent("filterOrdersByMobile", { detail: { mobile, orders: matchedOrders } }));
        } else {
          console.log("⚠️ No orders found for this mobile number.");
          window.dispatchEvent(new CustomEvent("clearOrderList"));
        }
  
        // ✅ Fetch customer details if available
        const customerResponse = await axios.get(`https://astrovidhya.in/api/customers/${mobile}`);
        const customerData = customerResponse.data;
  
        if (customerData) {
          console.log("✅ Customer Data Fetched:", customerData);
          setFormData((prev) => ({
            ...prev,
            customer_name: customerData.name || "",
            shipping_address: customerData.address || "",
            pin: customerData.pincode || "",
            city: customerData.city || "",
            district: customerData.district || "",
            state: customerData.state || "",
            mobile: customerData.mobile || "",
            products: customerData.products || [],
          }));
        } else {
          alert("Customer not found.");
        }
  
      } catch (error) {
        console.error("❌ Error fetching customer details:", error);
     //   alert("Customer not found.");
      }
    }
  };
  
  useEffect(() => {
    const handleVillageSelection = (event) => {
      const selectedVillage = event.detail.village;
      console.log("🏡 Village Selected:", selectedVillage);
  
      setFormData((prev) => ({
        ...prev,
        village: selectedVillage,
      }));
  
      // ✅ Focus courier field
      setTimeout(() => {
        courierRef.current?.focus();
        console.log("📦 Focused courier dropdown");
      }, 150);
    };
  
    window.addEventListener("villageSelected", handleVillageSelection);
    return () => {
      window.removeEventListener("villageSelected", handleVillageSelection);
    };
  }, []);
  
  
  
  
  
  


  const handlePincodeKeyDown = async (e) => {
    if (e.key === "Enter") {
      const pin = formData.pin.trim();
      if (!/^\d{6}$/.test(pin)) {
        alert("Please enter a valid 6-digit PIN code.");
        return;
      }
  
      try {
        const response = await axios.get(`https://astrovidhya.in/api/pincode/${pin}`);
        const { city, district, state, village } = response.data;
  
        setFormData((prev) => ({
          ...prev,
          city,
          district,
          state,
          village,
        }));
  
        const courierResponse = await axios.get(`https://astrovidhya.in/api/couriers/pincode/${pin}`);
        const availableCouriers = courierResponse.data;
        if (availableCouriers.length > 0) {
          setFormData((prev) => ({
            ...prev,
            courier: availableCouriers[0]._id,
          }));
        }
  
        const syncEvent = new CustomEvent("pincodeSync", { detail: { pincode: pin } });
        window.dispatchEvent(syncEvent);
  
        // ✅ Focus village panel after slight delay
        setTimeout(() => {
        //  villagePanelRef.current?.focus();
          window.dispatchEvent(new Event("focusVillagePanel")); // ✅ This now works!

          console.log("🟢 Village panel focused from OrderCreate");
        }, 200);
      } catch (error) {
        console.error("❌ Error fetching pincode details:", error);
        alert("Failed to fetch details for the entered PIN code.");
      }
    }
  };
  
  
  
  



  const handleChange = (event) => {
    const { name, value } = event.target;
  
    // ✅ Convert all input values to uppercase
    const upperCaseValue = value.toUpperCase();
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: upperCaseValue,
    }));
  };
  
  const handleDiscountChange = (e) => {
    const discountVal = Math.min(Number(e.target.value), 200000);
    setFormData((prev) => ({ ...prev, discount: discountVal }));
  };

  const handleProductChange = (index, productId) => {
    const selectedProduct = products.find((p) => p._id === productId);
    if (!selectedProduct) return;

    setFormData((prev) => {
      const updatedProducts = [...prev.products];
      updatedProducts[index] = {
        productId: selectedProduct._id,
        productName: selectedProduct.productName || "",
        quantity: updatedProducts[index]?.quantity || 1,
        price: selectedProduct.price || 0,
      };
      return { ...prev, products: updatedProducts };
    });
  };

  const handleQuantityChange = (index, qty) => {
    const updatedProducts = [...formData.products];
    updatedProducts[index].quantity = parseInt(qty, 10) || 1;
    setFormData((prev) => ({ ...prev, products: updatedProducts }));
    calculateTotalAmount(updatedProducts, formData.discount);
  };

  const handleAddProduct = () => {
    setFormData((prev) => ({
      ...prev,
      products: [...prev.products, { productId: '', productName: '', quantity: 1, price: 0 }],
    }));
  };

  const handleRemoveProduct = (index) => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products.filter((_, i) => i !== index),
    }));
  };

  const handleReset = () => {
    const savedCaller = localStorage.getItem("persistentCaller") || "";
    const savedProducts = JSON.parse(localStorage.getItem("persistentProducts")) || [
      { productId: '', productName: '', quantity: 1, price: 0 },
    ];
  
    setFormData({
      order_no: "",
      customer_name: "",
      order_date: new Date().toISOString().split("T")[0],
      order_time: new Date().toLocaleTimeString("en-US", { hour12: false }),
      total_amount: 0,
      products: savedProducts,
      shipping_address: "",
      assigned_to: savedCaller,
      courier: "",
      pin: "",
      mobile: "",
      so: "",
      village: "",
      city: "",
      district: "",
      state: "",
      payment_method: "",
      discount: 0,
    //  call_type: "",
      _id: null,
      sent_to_caller: false,
    });
  };
  


  // ----------------------
  // HANDLE SUBMIT
  // ----------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
  
      const orderData = {
        ...formData,
       // call_type: formData.call_type || "Confirmed", // ✅ Use a valid enum value

        courier: formData.courier || "N/A",
        payment_method: formData.payment_method || "COD",
        discount: formData.discount || 0,
        total_amount: formData.total_amount || 0,
        original_total_amount: formData.original_total_amount || formData.total_amount,
        sent_to_caller: formData.sent_to_caller || false,
      };
  
      const headers = { Authorization: `Bearer ${token}` };
  
      if (formData._id) {
        const url = `https://astrovidhya.in/api/orders/${formData._id}`;
        const response = await axios.put(url, orderData, { headers });
        alert(`✏️ Order Updated Successfully! Order No: ${response.data.order_no}`);
      } else {
        const url = "https://astrovidhya.in/api/orders/generate";
        const response = await axios.post(url, orderData, { headers });
        alert(`✅ Order Created Successfully! Order No: ${response.data.order_no}`);
      }
  
      // 🧠 Save caller & products before resetting (use localStorage instead of state)
localStorage.setItem("persistentCaller", formData.assigned_to);
localStorage.setItem("persistentProducts", JSON.stringify(formData.products));



  
      handleReset();
  
      if (onOrderAdded) {
        onOrderAdded();
      }
    } catch (error) {
      console.error("❌ Error submitting order:", error.response?.data || error.message);
      alert("Failed to submit order. Check console.");
    }
  };
  
  

  

  // ----------------------
  // RENDER
  // ----------------------
  return (
    <div className="create-order bg-white px-4 py-2 rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">Create Order</h2>
      <div
  id="villageListPanel"
  tabIndex={0}
  ref={villagePanelRef}
  style={{ outline: "none", height: 0 }}
></div>


      <form id="orderCreateForm" tabIndex="-1" onSubmit={handleSubmit} className="grid gap-1 text-sm">


        {/* Date */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Order Date</label>
          <input
            type="date"
            name="order_date"
            value={formData.order_date}
            onChange={handleChange}
            className="flex-1 px-3 py-2 border rounded-md"
            required
          />
        </div>

        {/* Order Time (Hidden) */}
        <input type="hidden" name="order_time" value={formData.order_time} />

        {/* Mobile */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Mobile</label>
          <input
  type="text"
  name="mobile"
  value={formData.mobile}
  onChange={handleChange}
  onKeyDown={handleMobileKeyDown} // ✅ Attach event listener
  placeholder="Enter customer's mobile number"
  maxLength={10}
  className="flex-1 px-3 py-2 border rounded-md"
  required
/>

        </div>

        {/* PIN */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">PIN</label>
          <input
            type="text"
            name="pin"
            value={formData.pin}
           
            onChange={(e) => {
              const pinVal = e.target.value;
              setFormData((prev) => ({
                ...prev,
                pin: pinVal,
                city: '',
                district: '',
                state: '',
              }));
            }}
            onKeyDown={handlePincodeKeyDown} // <-- attach it here
            placeholder="Enter PIN code"
            maxLength={6}
            className="flex-1 px-3 py-2 border rounded-md"
            required
          />
        </div>

        {/* Courier */}
        <div className="flex items-center gap-4 mb-2">
          <label className="w-1/4 font-medium">Courier</label>
          <select
  name="courier"
  value={formData.courier}
  onChange={(e) => setFormData({ ...formData, courier: e.target.value })}
  ref={courierRef} // ✅ focus moves here after village selection
   className="flex-1 px-3 py-2 border rounded-md"
>
  <option value="">Select Courier</option>
  {couriers.map((c) => (
    <option key={c._id} value={c._id}>
      {c.name}
    </option>
  ))}
</select>

        </div>

        {/* Customer Name */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Name</label>
          <input
            type="text"
            name="customer_name"
            value={formData.customer_name}
            onChange={handleChange}
            placeholder="Customer Name"
            className="flex-1 px-3 py-2 border rounded-md"
            maxLength={40}
            required
          />
        </div>

   {/* S/o */}
<div className="flex items-center gap-4">
  <label className="w-1/4 font-medium">S/o</label>
  <input
    type="text"
    name="so"
    value={formData.so || ""} // ✅ Ensure it never becomes `undefined`
    onChange={handleChange}
    placeholder="S/o"
    className="flex-1 px-3 py-2 border rounded-md"
    maxLength={40}
  />
</div>


        {/* Shipping Address */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Address</label>
          <textarea
            name="shipping_address"
            value={formData.shipping_address}
            onChange={handleChange}
            placeholder="Full address"
            className="flex-1 px-3 py-2 border rounded-md"
            rows={2}
            maxLength={110}
            required
          />
        </div>

        {/* Village */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Village</label>
          <input
            type="text"
            name="village"
            value={formData.village}
            onChange={handleChange}
            placeholder="Village"
            className="flex-1 px-3 py-2 border rounded-md"
            maxLength={40}
          />
        </div>

        {/* City */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">City</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City"
            className="flex-1 px-3 py-2 border rounded-md"
            maxLength={40}
          />
        </div>

        {/* District */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">District</label>
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            placeholder="District"
            className="flex-1 px-3 py-2 border rounded-md"
            maxLength={40}
          />
        </div>

        {/* State */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">State</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            placeholder="State"
            className="flex-1 px-3 py-2 border rounded-md"
            maxLength={40}
          />
        </div>

        {/* PRODUCTS */}
        <h3 className="mt-3 font-bold">Products</h3>
{(formData.products || []).map((item, index) => (
  <div key={index} className="flex items-center w-full gap-3">
    {/* Product Selector */}
    <select
      value={item.productId}
      onChange={(e) => handleProductChange(index, e.target.value)}
      className="flex-1 px-3 py-2 border rounded-md h-10 focus:outline-none focus:ring-1 focus:ring-blue-400"
      required
    >
      <option value="">Select Product</option>
      console.log("🛠️ Products in dropdown:", products);

{products.map((prod) => (
 <option key={prod._id} value={prod._id}>{prod.productName || prod.name}</option>

))}

    </select>

    {/* Quantity Field */}
    <input
      type="number"
      value={item.quantity}
      onChange={(e) => handleQuantityChange(index, e.target.value)}
      min="1"
      className="w-24 h-10 px-3 mt-3 border rounded-md text-center focus:outline-none focus:ring-1 focus:ring-blue-400"
      required
    />

    {/* Remove Button */}
    <button
      type="button"
      onClick={() => handleRemoveProduct(index)}
      className="w-24 h-10 px-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
    >
      Remove
    </button>
  </div>
))}

        <button
          type="button"
          onClick={handleAddProduct}
          className="w-full mt-2 px-3 py-2 text-white rounded-md"
          style={{ backgroundColor: '#03c9d7' }}
        >
          + Add More Products
        </button>

        {/* Discount */}
        <div className="flex items-center w-full gap-4 mt-3">
          <label className="w-1/4 font-medium">Discount:</label>
          <input
            type="number"
            value={formData.discount}
            onChange={handleDiscountChange}
            className="flex-1 px-3 py-2 border rounded-md text-center"
          />
        </div>

        {/* Total Amount */}
        <h3 className="mt-3">Total Amount: ₹{formData.total_amount}</h3>

        {/* Caller / Staff Member */}
        <div className="flex items-center gap-4">
          <label className="w-1/4 font-medium">Caller</label>
          <select
  name="assigned_to"
  value={formData.assigned_to}
  onChange={(e) => setFormData({ ...formData, assigned_to: e.target.value })}
   className="flex-1 px-3 py-2 border rounded-md"
>
  <option value="">Select Caller</option>
  {staffMembers.map((staff) => (
    <option key={staff._id} value={staff._id}>
      {staff.name}
    </option>
  ))}
</select>

        </div>

   {/* Payment Method */}
<div className="flex items-center gap-4">
  <label className="w-1/4 font-medium">Payment Method</label>
  <select
    name="payment_method"
    value={formData.payment_method}
    onChange={(e) => {
      console.log("📌 Selected Payment Method:", e.target.value); // Debugging
      setFormData((prev) => ({
        ...prev,
        payment_method: e.target.value,
      }));
    }}
    className="flex-1 px-3 py-2 border rounded-md"
    required
  >
    <option value="">Select Payment Method</option>
    {paymentMethods.map((pm) => (
      <option key={pm} value={pm}>{pm}</option>
    ))}
  </select>
</div>


   {/*
<div className="flex items-center gap-4">
  <label className="w-1/4 font-medium">Call Type</label>
  <select
    name="call_type"
    value={formData.call_type}
    onChange={(e) => {
      setFormData((prev) => ({
        ...prev,
        call_type: e.target.value,
      }));
    }}
    className="flex-1 px-3 py-2 border rounded-md"
    required
  >
    <option value="">Select Call Type</option>
    {callTypes.map((ct) => (
      <option key={ct} value={ct}>
        {ct}
      </option>
    ))}
  </select>
</div>
*/}



{/* Order No. */}
<div className="flex items-center gap-4">
  <label className="w-1/4 font-medium">Order No.</label>
  <input
    type="text"
    name="order_no"
    value={formData.order_no}
    readOnly
    className="flex-1 px-3 py-2 border rounded-md bg-gray-100 cursor-not-allowed"
  />
</div>



        {/* Submit + Reset */}
        <div className="flex justify-between mt-4 gap-6">
          <button
            type="submit"
            className="w-1/2 text-white py-2 px-4 rounded"
            style={{ backgroundColor: '#03c9d7' }}
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="w-1/2 text-white py-2 px-4 rounded"
            style={{ backgroundColor: '#81e2ed' }}
          >
            Reset
          </button>
        </div>

        {/* ✅ Sent to Caller checkbox (only for admin)
{localStorage.getItem("username") === "admin" && (
  <div className="flex items-center gap-4 mt-3">
    <label className="w-1/4 font-medium">Send to Caller?</label>
    <input
      type="checkbox"
      name="sent_to_caller"
      checked={formData.sent_to_caller}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          sent_to_caller: e.target.checked,
        }))
      }
    /> 
  </div> 
)} */}

      </form>
    </div>
  );
};

export default OrderCreate;
